export default function getISODateToFormatted(dateString) {
  // convert YYYY-MM-DD to MM-DD-YYYY
  let split = dateString.split('-');
  split = split.map((e) => (e.length === 1 ? `0${e}` : e));
  return `${split[1]}-${split[2]}-${split[0]}`;
}
